// Global registry for managing connected animations
export interface AnimationController {
  triggerAnimation: () => void;
  reset: () => void;
  isRunning: boolean;
}

class AnimationRegistry {
  private registry = new Map<string, AnimationController>();

  register(id: string, controller: AnimationController) {
    console.log(`Registering animation with id: ${id}`);
    this.registry.set(id, controller);
  }

  unregister(id: string) {
    console.log(`Unregistering animation with id: ${id}`);
    this.registry.delete(id);
  }

  trigger(id: string) {
    console.log(`Attempting to trigger animation with id: ${id}`);
    console.log(`Registry has ${this.registry.size} animations:`, Array.from(this.registry.keys()));
    const controller = this.registry.get(id);
    if (controller) {
      console.log(`Found controller for ${id}, triggering animation`);
      controller.triggerAnimation();
      return true;
    }
    console.warn(`Animation with id "${id}" not found in registry`);
    return false;
  }

  reset(id: string) {
    const controller = this.registry.get(id);
    if (controller) {
      controller.reset();
      return true;
    }
    return false;
  }

  getController(id: string): AnimationController | undefined {
    return this.registry.get(id);
  }

  getAllIds(): string[] {
    return Array.from(this.registry.keys());
  }
}

// Singleton instance
export const animationRegistry = new AnimationRegistry();